export const base_filter = [
	{ key: "specie", label: "Especie", type: "text", value: "", visible: true, placeholder: "Especie" },
	{ key: "variety", label: "Variedad", type: "text", value: "", visible: true, placeholder: "Variedad" },
];

export const base_table = { page: 1, per_page: 100, order_by: "name", order_dir: "asc" };

export const base_object = { id: "", specie: "", varieties: [], varieties_options: [] };
